export const sortBreedsByFeatured = (breeds, featuredNames = []) => {
  const names = featuredNames.filter(Boolean);
  if (!names.length) {
    return breeds;
  }

  const byLabel = new Map(breeds.map(breed => [breed.label, breed]));
  const featured = [];
  const featuredLabels = new Set();

  names.forEach(name => {
    const breed = byLabel.get(name);
    if (breed && !featuredLabels.has(breed.label)) {
      featured.push(breed);
      featuredLabels.add(breed.label);
    }
  });

  if (!featured.length) {
    return breeds;
  }

  const rest = breeds
    .filter(breed => !featuredLabels.has(breed.label))
    .sort((a, b) => a.label.localeCompare(b.label));

  return [...featured, ...rest];
};
